module.exports = __webpack_public_path__ + "img/chalkline.d7a627ad.webp";